import { CARRIER } from '~/basket/model/constants'

import { getCurrentHost } from './getCurrentHost'

const getCarrierByDomain = (): string => {
  const host = getCurrentHost()
  const [, domain]: string[] = host.split('.')
  const availableCarriers: string[] = [CARRIER.PARCEL, CARRIER.EXPRESS, CARRIER.EXPRESS_ECONOMY]
  const fallback = availableCarriers[0]

  return domain
    ? availableCarriers.find((value) => value.replace(/-/g, '').toLowerCase() === domain) || fallback
    : fallback
}
export { getCarrierByDomain }
